import { render, staticRenderFns } from "./Tvshow.vue?vue&type=template&id=64a9de39"
import script from "./Tvshow.vue?vue&type=script&lang=js"
export * from "./Tvshow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports